<template>
  <div>
    <Navbar activeDirectory="storico" :activePage="activePage"></Navbar>
    <div class="container-fluid">
      <div class="row mb-2"><div class="col"><h4 class="font-bold pull-left">Storico {{ activePage }}</h4></div></div>
      <div class="row">
        <div class="col">
          <div class="row">
            <div class="col-4">
              <div class="form-group row">
                <label class="col-2 col-form-label font-bold">Interventi</label>
                <div class="col-10">
                  <tags-input element-id="tags"
                    v-model="interventi"
                    placeholder="Seleziona interventi"
                    :existing-tags="getExistingTags()"
                    :typeahead="true"></tags-input>
                </div>
              </div>
            </div>
            <div class="col-3">
              <div class="form-group row">
                <label class="col-2 col-form-label font-bold">Squadra</label>
                <div class="col-10">
                  <div class="dropdown">
                    <!-- Dropdown Input -->
                    <input class="dropdown-input"
                      :name="name"
                      :options="teams"
                      @focus="showOptions()"
                      @blur="exit()"
                      @keyup="keyMonitor"
                      v-model="squadra"
                      :disabled="disabled"
                      :placeholder="placeholder" />

                    <!-- Dropdown Menu -->
                    <div class="dropdown-content"
                      v-show="optionsShown">
                      <div
                        class="dropdown-item"
                        @mousedown="selectOption(option)"
                        v-for="(option, index) in filteredOptions"
                        :key="index">
                          {{ option.team || option.id || '-' }}
                      </div>
                    </div>
                  </div>

                  <!--<input element-id="squadra" class="form-control" v-model="squadra" placeholder="Seleziona squadra"/>-->
                </div>
              </div>
            </div>
     
            <div class="col-2">
              <div class="form-group row">
                <label class="col-2 col-form-label font-bold">Da</label>
                <div class="col-10">
                  <input type="date" class="form-control" v-model="dateFrom" />
                </div>
              </div>
            </div>
            <div class="col-2">
              <div class="form-group row">
                <label class="col-2 col-form-label font-bold">A</label>
                <div class="col-10">
                  <input type="date" class="form-control" v-model="dateTo" />
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-1">
              <button class="btn btn-block" @click="resetData()">Reset</button>
            </div>
            <div class="col-1">
              <button class="btn btn-block btn-primary" @click="fetchData()">Mostra</button>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-body" v-if="!searching">
          <div class="row" v-if="activePage=='lavori'">
            <table class="table table-striped table-sm" v-if="lavori.length > 0">
              <thead class="thead-light">
                <th></th>
                <th>Intervento</th>
                <th>Squadra</th>
                <th>Presso</th>
                <th>Avviato in data</th>
                <th>Concluso in data</th>
                <th>Supporto</th>
                <th></th>
              </thead>
              <tbody>
                <tr v-for="(item, key) in lavori" v-bind:key="key" :class="[{'lineThrough' : item.deleted}]">
                  <td class="align-middle">
                    <i class="fa fa-circle" :class="[{'text-success' : !item.fine.tempo}]" v-tooltip="getTooltipOfLavori(item.fine.tempo)"></i>
                  </td>
                  <td class="align-middle">
                    <span
                      class="badge text-uppercase"
                      :class="classeInterventoBadge(item.intervento)"
                    >{{ item.intervento }}</span>
                  </td>
                  <td class="align-middle">{{ item.team.nome }}</td>
                  <td class="align-middle">{{ item.strada }}</td>
                  <td class="align-middle">{{ formatTimestampToLocalDate(item.inizio.tempo) }}</td>
                  <td class="align-middle">{{ formatTimestampToLocalDate(item.fine.tempo) }}</td>
                  <td class="align-middle"><span v-html="formatSupporto(item.supporto)"></span></td>
                  <td class="align-middle"><button @click="mostraDettagliLavoro(item)" class="btn btn-primary btn-sm text-white mr-2" v-tooltip="{content:'Mostra dettagli', placement: 'left'}"><i class="mdi mdi-magnify"></i></button></td>
                </tr>
              </tbody>
            </table>
            <div class="col" v-else>Nessun dato da mostrare</div>
          </div>
          <div class="row" v-if="activePage=='segnalazioni'">
            <table class="table table-striped table-sm" v-if="segnalazioni.length > 0">
              <thead class="thead-light">
                <th>Intervento</th>
                <th>Segnalato da</th>
                <th>Gestito da</th>
                <th>In data</th>
                <th>Presso</th>
                <th></th>
              </thead>
              <tbody>
                <tr v-for="(item, key) in segnalazioni" v-bind:key="key" :class="[{'lineThrough' : item.deleted}]">
                  <td class="align-middle">
                    <span
                      class="badge text-uppercase"
                      :class="classeInterventoBadge(item.intervento)"
                    >{{ item.intervento }}</span>
                  </td>
                  <td class="align-middle">{{ item.team_segnalatore.nome }}</td>
                  <td class="align-middle"><span v-if="item.team_operatore">{{ item.team_operatore.nome }}</span><span v-else>-</span></td>                  
                  <td class="align-middle">{{ formatTimestampToLocalDate(item.tempo) }}</td>
                  <td class="align-middle">{{ item.strada }}</td>
                  <td class="align-middle"><button @click="mostraDettagliSegnalazione(item)" class="btn btn-primary btn-sm text-white mr-2" v-tooltip="{content:'Mostra dettagli', placement: 'left'}"><i class="mdi mdi-magnify"></i></button></td>
                </tr>
              </tbody>
            </table>
            <div class="col" v-else>Nessun dato da mostrare</div>
          </div>
          <div class="row" v-if="activePage=='richieste'">
            <table class="table table-striped table-sm" v-if="richieste.length > 0">
              <thead class="thead-light">
                <th>Intervento</th>
                <th>Richiesto da</th>
                <th>In data</th>
                <th>Presso</th>
                <th>Esito Richiesta</th>
                <th></th>
              </thead>
              <tbody>
                <tr v-for="(item, key) in richieste" v-bind:key="key">
                  <td class="align-middle">
                    <span
                      class="badge text-uppercase"
                      :class="classeInterventoBadge(item.intervento)"
                    >{{ item.intervento }}</span>
                  </td>
                  <td class="align-middle">{{ item.team_richiedente.nome }}</td>
                  <td class="align-middle">{{ formatTimestampToLocalDate(item.tempo) }}</td>
                  <td class="align-middle">{{ item.strada }}</td>
                  <td class="align-middle">{{ formatEsitoRichiesta(item) }}</td>
                  <td class="align-middle"><button @click="mostraDettagliRichiesta(item)" class="btn btn-primary btn-sm text-white mr-2" v-tooltip="{content:'Mostra dettagli', placement: 'left'}"><i class="mdi mdi-magnify"></i></button></td>
                </tr>
              </tbody>
            </table>
            <div class="col" v-else>Nessun dato da mostrare</div>
          </div>
        </div>
        <div class="card-body" v-else>
          <i class="fa fa-spinner fa-spin fa-2x"></i>
        </div>
      </div>
    </div>

    <!-- Modale di una RICHIESTA -->
    <modal name="richiesta" width="800" height="auto">
      <div v-if="forceRefreshRichiesta && Object.entries(richiesta).length > 0">
        <div class="card m-b-20" style="border: 0;">
          <h4 class="card-header font-bold text-uppercase"><small>Richiesta di supporto per</small> {{ richiesta.intervento }} <small>presso</small> {{ richiesta.strada }} <small class="pull-right" style="cursor: pointer;" @click="$modal.hide('richiesta');">Chiudi <i class="fa fa-times"></i></small></h4>
          <div class="card-body">
            <div class="row">
              <div class="col-4">
                <img :src="richiesta.foto" style="width: 100%;">
              </div>
              <div class="col-8">
                <table class="table table-striped table-sm">
                  <tbody>                    
                    <tr>
                      <th>Intervento</th>
                      <td><span class="badge text-uppercase" :class="classeInterventoBadge(richiesta.intervento)">{{ richiesta.intervento }}</span></td>
                    </tr>
                    <tr>
                      <th>Identificativo</th>
                      <td><span>{{ richiesta.id }}</span></td>
                    </tr>
                    <tr>
                      <th>Richiesta da</th>
                      <td>{{ richiesta.team_richiedente.nome }}</td>
                    </tr>
                    <tr>
                      <th>In data</th>
                      <td>{{ formatTimestampToLocalDate(richiesta.tempo) }}</td>
                    </tr>
                    <tr>
                      <th>Strada interessata</th>
                      <td>{{ richiesta.strada }}</td>
                    </tr>
                    <tr>
                      <th>Esito</th>
                      <td>{{ formatEsitoRichiesta(richiesta) }}</td>
                    </tr>
                    <tr>
                      <th>Latitudine</th>
                      <td>{{ richiesta.latitudine }}</td>
                    </tr>
                    <tr>
                      <th>Longitudine</th>
                      <td>{{ richiesta.longitudine }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div> 
          </div>                     
        </div>
      </div>      
    </modal>

    <!-- Modale di una SEGNALAZIONE -->
    <modal name="segnalazione" width="800" height="auto">
      <div v-if="forceRefreshSegnalazione && Object.entries(segnalazione).length > 0">
        <div class="card m-b-20" style="border: 0;">
          <h4 class="card-header font-bold text-uppercase">{{ segnalazione.intervento }} <small>presso</small> {{ segnalazione.strada }} <small class="pull-right" style="cursor: pointer;" @click="$modal.hide('segnalazione');">Chiudi <i class="fa fa-times"></i></small></h4>
          <div class="card-body">
            <div class="row">
              <div class="col-4">
                <img :src="segnalazione.foto" style="width: 100%;">
              </div>
              <div class="col-8">
                <table class="table table-striped table-sm">
                  <tbody>                    
                    <tr>
                      <th>Intervento</th>
                      <td><span class="badge text-uppercase" :class="classeInterventoBadge(segnalazione.intervento)">{{ segnalazione.intervento }}</span></td>
                    </tr>
                    <tr>
                      <th>Identificativo</th>
                      <td><span>{{ segnalazione.id }}</span></td>
                    </tr>
                    <tr>
                      <th>Segnalato da</th>
                      <td>{{ segnalazione.team_segnalatore.nome }}</td>
                    </tr>
                    <tr>
                      <th>In data</th>
                      <td>{{ formatTimestampToLocalDate(segnalazione.tempo) }}</td>
                    </tr>
                    <tr v-if="segnalazione.team_operatore.id">
                      <th>Gestita da</th>
                      <td>{{ segnalazione.team_operatore.nome }}</td>
                    </tr>
                    <tr>
                      <th>Strada interessata</th>
                      <td>{{ segnalazione.strada }}</td>
                    </tr>
                    <tr>
                      <th>Latitudine</th>
                      <td>{{ segnalazione.latitudine }}</td>
                    </tr>
                    <tr>
                      <th>Longitudine</th>
                      <td>{{ segnalazione.longitudine }}</td>
                    </tr>
                    <tr>
                      <th>Note</th>
                      <td>{{ segnalazione.note }}</td>
                    </tr>
                  </tbody>
                </table>
                 <div class="text-center">
                  <router-link :to="{name: 'modifica-segnalazione', params: {uuid: segnalazione.uuid}}" class="btn btn-primary btn-sm" v-if="tipologia=='B'">Modifica</router-link>                  
                </div>
              </div>
            </div>
            <div class="row" v-if="segnalazione.intervento=='emergenza_carreggiata' || segnalazione.intervento == 'rifiuto' || segnalazione.intervento == 'rifiuto_speciale'"><div class="col" align="center"><button class="btn btn-primary" @click="downloadEmergenza(segnalazione)">Scarica</button></div></div> 
          </div>                     
        </div>
      </div>      
    </modal>

    <!-- Modale di un lavoro -->
    <modal name="lavoro" width="800" height="auto">
      <div v-if="forceRefreshLavoro && Object.entries(lavoro).length > 0">
        <div class="card m-b-20" style="border: 0;">
          <h4 class="card-header font-bold text-uppercase"><small>Intervento, </small> {{ lavoro.intervento }} <small>presso</small> {{ lavoro.strada }} <small class="pull-right" style="cursor: pointer;" @click="$modal.hide('lavoro');">Chiudi <i class="fa fa-times"></i></small></h4>
          <div class="card-body" >
            <div class="row">
              <div class="col-4" v-if="!lavoro.fine.tempo">
                <img :src="lavoro.inizio.foto" style="width: 100%;">
              </div>
              <div class="col-4" v-else>
                <div align="center" class="mb-1">
                  <span class="badge" style="cursor: pointer;" :class="[{'badge-primary': mostraFotoLavoro==='inizio'}]" @click="mostraFotoLavoro='inizio'">Inizio</span>
                  <span class="badge" style="cursor: pointer;" :class="[{'badge-primary': mostraFotoLavoro==='fine'}]" @click="mostraFotoLavoro='fine'">Fine</span>
                </div>                
                <img :src="lavoro.inizio.foto" style="width: 100%;" v-if="mostraFotoLavoro==='inizio'">
                <img :src="lavoro.fine.foto" style="width: 100%;"  v-if="mostraFotoLavoro==='fine'">
              </div>
              <div class="col-8">
                <table class="table table-striped table-sm">
                  <tbody>                    
                    <tr>
                      <th>Intervento</th>
                      <td><span class="badge text-uppercase" :class="classeInterventoBadge(lavoro.intervento)">{{ lavoro.intervento }}</span></td>
                    </tr>
                    <tr>
                      <th>Identificativo</th>
                      <td><span>{{ lavoro.id }}</span></td>
                    </tr>
                    <tr>
                      <th>Team</th>
                      <td>{{ lavoro.team.nome }}</td>
                    </tr>
                    <tr>
                      <th>Avviato in data</th>
                      <td>{{ formatTimestampToLocalDate(lavoro.inizio.tempo) }}</td>
                    </tr>
                    <tr v-if="lavoro.fine.tempo">
                      <th>Concluso in data</th>
                      <td>{{ formatTimestampToLocalDate(lavoro.fine.tempo) }}</td>
                    </tr>
                    <tr>
                      <th>Strada interessata</th>
                      <td>{{ lavoro.strada }}</td>
                    </tr>
                    <tr v-if="lavoro.inizio.latitudine">
                      <th>Inizio (Lat, Lon)</th>
                      <td>({{ lavoro.inizio.latitudine }}, {{ lavoro.inizio.longitudine }})</td>
                    </tr>
                    <tr v-if="lavoro.fine.latitudine">
                      <th>Fine (Lat, Lon)</th>
                      <td>({{ lavoro.fine.latitudine }}, {{ lavoro.fine.longitudine }})</td>
                    </tr>
                    <tr v-if="lavoro.distanza">
                      <th>Distanza (metri)</th>
                      <td>{{ lavoro.distanza }}</td>
                    </tr>
                    <tr v-if="lavoro.distanza">
                      <th>Distanza lineare misurata (metri)</th>
                      <td>{{ lavoro.distanza_misurata ? lavoro.distanza_misurata : 0 }}</td>
                    </tr>
                    <tr v-if="lavoro.numero_buche">
                      <th>Buche riparate</th>
                      <td>{{ lavoro.numero_buche }}</td>
                    </tr>
                  </tbody>
                </table>
                <div class="text-center">
                  <router-link :to="{name: 'modifica-lavoro', params: {uuid: lavoro.uuid}}" class="btn btn-primary btn-sm" v-if="tipologia=='B' && lavoro.fine">Modifica</router-link>                  
                </div>
                
              </div>
            </div> 
          </div>                     
        </div>
      </div>      
    </modal>
  </div>
</template>

<script>
import { Navbar } from "@/components";

export default {
  components: {
    Navbar,
  },
  name: 'Dropdown',
  template: 'Dropdown',
  props: {
    name: {
      type: String,
      required: false,
      default: 'dropdown',
      note: 'Input name'
    },
    placeholder: {
      type: String,
      required: false,
      default: 'Seleziona una squadra',
      note: 'Placeholder of dropdown'
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
      note: 'Disable the dropdown'
    },
    maxItem: {
      type: Number,
      required: false,
      default: 30,
      note: 'Max items showing'
    }
  },
  data() {
    return {
     
      tipologia: localStorage.getItem('tipologia'),

      activePage: undefined,
      lotto: 1,
      searching: false,
      team:{},
      teams:[],
      teamTemp:[],
      selected: undefined,
      optionsShown: false,
      squadra: '',
      // Filter
      interventi: [],
     // squadra:undefined,
      dateFrom: undefined,
      dateTo: null,

      // lavori
      lavori: [],
      lavoro: {},
      forceRefreshLavoro: true,
      mostraFotoLavoro: 'inizio',

      // segnalazioni
      segnalazioni: [],
      segnalazione: {},
      forceRefreshSegnalazione: true,

      // richieste
      richieste: [],
      richiesta: {},
      forceRefreshRichiesta: true,
    };
  },

  watch: {
    $route(to, from) {
      if (to.name == "history" && to.path != from.path) {
        this.activePage = this.$route.params.scope;
        this.fetchData();
      }
    },
    squadra() {
      if (this.filteredOptions.length === 0) {
        this.selected = {};
      } else {
        console.log(this.filteredOptions[0]);
        this.selected = this.filteredOptions[0];
      }
      this.$emit('filter', this.squadra);
    }
  },

  computed: {
    filteredOptions() {
      const filtered = [];
      const regOption = new RegExp(this.squadra, 'ig');
      for (const option of this.teams) {
        if (this.squadra.length < 1 || option.team.match(regOption) ){
          if (filtered.length < this.maxItem) filtered.push(option);

        }
      }
      return filtered;
    },
  },

  created() {
    // Active page
    this.activePage = this.$route.params.scope;

    // Get lotto
    if (localStorage.getItem("lotto")) {
      this.lotto = localStorage.getItem("lotto");
    }

    // Get dateFrom
    if (localStorage.getItem("dateFrom")) {
      this.dateFrom = localStorage.getItem("dateFrom");
    } 
    // else {
    //   var today = new Date();
    //   var oneDay = 1000 * 60 * 60 * 24;
    //   this.dateFrom = new Date(today - oneDay).toISOString().split("T")[0];
    // }

    // Get dateTo
    if (localStorage.getItem("dateTo")) {
      this.dateTo = localStorage.getItem("dateTo");
    }
    this.$emit('selected', this.selected);

  },

  mounted() {
    this.fetchData();
  },

  methods: {
    //vue-suggestion 
   selectOption(option) {
      this.selected = option;
      this.optionsShown = false;
      this.squadra = this.selected.team;
      this.$emit('selected', this.selected);
    },
    showOptions(){
      if (!this.disabled) {
        this.squadra = '';
        this.optionsShown = true;
      }
    },
    exit() {
      console.log(this.selected.team);
      this.squadra = this.selected.team;
      
      this.$emit('selected', this.selected);
      this.optionsShown = false;
    },
    // Selecting when pressing Enter
    keyMonitor: function(event) {
      if (event.key === "Enter" && this.filteredOptions[0])
        this.selectOption(this.filteredOptions[0]);
    },
    // Main method
    fetchData() {
      this.searching = true;
      this.fetchTeams();

      // Save local storage
      if (this.dateFrom){
        localStorage.setItem("dateFrom", this.dateFrom);
      }

      if(this.dateTo){
        localStorage.setItem("dateTo", this.dateTo);
      }     

      // TODO: interventi in local storage

      var args = []
      

      if ( this.interventi.length > 0 ){
        var interventiArgs = 'interventi='
        for (var i in this.interventi) {
          interventiArgs += `${this.interventi[i].key},`
        }
        interventiArgs = interventiArgs.substring(0, interventiArgs.length - 1);
        args.push(interventiArgs);
      }
      if( this.squadra ) {
        args.push(`squadra=${this.squadra}`)
      }
      
      if( this.dateFrom ) {
        args.push(`date_from=${this.dateFrom}`)
      }

      if( this.dateTo ) {
        args.push(`date_to=${this.dateTo}`)
      }

      args='?'+ args.join('&')

      if (this.activePage == "lavori") {
        this.fetchLavori(args);
      }

      if (this.activePage == "segnalazioni") {
        this.fetchSegnalazioni(args);
      }

      if (this.activePage == "richieste") {
        this.fetchRichieste(args);
      }
    },

    // Reset
    resetData() {
      // Delete dateFrom
      localStorage.removeItem("dateFrom");
      var today = new Date();
      var oneDay = 1000 * 60 * 60 * 24;
      this.dateFrom = new Date(today - oneDay).toISOString().split("T")[0];

      // Delete dateTo
      localStorage.removeItem("dateTo");

      // TODO: delete interventi from localStorage
      this.interventi = [];

      this.fetchData();
    },

    // Fetch "lavori" history
    fetchLavori(args) {
      this.axios.get(`dockyard/${this.lotto}/history` + args).then(response => {
        this.lavori = response.data;
        var self = this;
        setTimeout(function(){
          self.searching = false;
        }, 2000);        
      });
    },

    // Fetch "segnalazioni" history
    fetchSegnalazioni(args) {
      this.axios.get(`notice/${this.lotto}/history` + args).then(response => {
        this.segnalazioni = response.data;
        var self = this;
        setTimeout(function(){
          self.searching = false;
        }, 2000);        
      });
    },

    // Fetch "richieste" history
    fetchRichieste(args) {
      this.axios.get(`support/${this.lotto}/history` + args).then(response => {
        this.richieste = response.data;
        var self = this;
        setTimeout(function(){
          self.searching = false;
        }, 2000);        
      });
    },

    // Tag in base alla tipologia di intervento
    getExistingTags() {
      var intBase = [
          { key: 'buca', value: 'BUCA' },
          { key: 'sfalcio', value: 'SFALCIO' },
          { key: 'segnaletica', value: 'SEGNALETICA' },
          { key: 'pulizia', value: 'PULIZIA' },
      ]
      var _ext = [
        { key: 'rifiuto', value: 'RIFIUTO' },
        { key: 'rifiuto_speciale', value: 'RIFIUTO SPECIALE' },
        { key: 'emergenza_carreggiata', value: 'EMERGENZA CARREGGIATA' }
      ]
      var intExt = _ext.concat(intBase);

      if (this.activePage == 'segnalazioni') {
        return intExt;
      } else {
        return intBase;
      }
    },

    // Classe Intervento
    // Individua la classe di badge
    // in base all'intervento
    classeInterventoBadge(intervento) {
      if (intervento == "buca") {
        return "badge-success";
      }
      if (intervento == "sfalcio") {
        return "badge-primary";
      }
      if (intervento == "segnaletica") {
        return "badge-dark";
      }
      if (intervento == "rifiuto") {
        return "badge-warning";
      }
      if (intervento == "rifiuto_speciale") {
        return "badge-purple";
      }
      if (intervento == "emergenza_carreggiata") {
        return "badge-danger";
      }
      if (intervento=='pulizia'){
        return 'badge-secondary';
      }
    },

    // Format Timestamp to Local Date
    formatTimestampToLocalDate(ts) {
      if (ts) {
        const today = new Date();
        var tsDate = new Date(ts * 1000);
        if (today.getDate() == tsDate.getDate() && today.getMonth() == tsDate.getMonth() && today.getFullYear() == tsDate.getFullYear()) {
          return `Oggi, ${tsDate.toLocaleTimeString()}`;
        } else {
          return tsDate.toLocaleString();
        }
      } else {
        return "-";
      }
    },

    // Format string for "supporto"
    formatSupporto(sup) {
      if ( sup.tempo && sup.team ) {
        if ( sup.confermato ) {
          return  `Con il supporto di <b>${sup.team}</b>`
        } else {
          if ( sup.accettato ) {
            return  `Supporto accettato da <b>${sup.team}</b>`
          } else {
            return  `Supporto assegnato a <b>${sup.team}</b>`
          } 
        }
      } else {
        if ( sup.tempo ) {
          return `Richiesto il ${this.formatTimestampToLocalDate(sup.tempo)}`
        } else {
          return '-'
        }        
      }
    },

    // Format esito richiesta
    formatEsitoRichiesta(item){
      console.log(item);
      // accettata|conclusa e confermata|conclusa e non confermata
      if ( item.stato === 'accettata' ) {
        return `Presa in carico da ${item.team_supporto.nome}`
      }
      if ( item.stato === 'conclusa e confermata' ) {
        return `Con il supporto di ${item.team_supporto.nome}`
      }
      if ( item.stato === 'conclusa e non confermata' ) {
        return `Conclusa senza il supporto di ${item.team_supporto.nome}`
      }
      return '-'
    },

    // Tootlip dei lavori
    getTooltipOfLavori (tempo) {
      if (!tempo) { return 'Lavoro in corso' }
    },

    // Mostra il modale con i dettagli di un
    // lavoro in corso
    mostraDettagliLavoro(lavoro) {
      this.lavoro = lavoro;
      this.$modal.show('lavoro');
      // turnaround
      this.forceRefreshLavoro = !this.forceRefreshLavoro;
      this.forceRefreshLavoro = !this.forceRefreshLavoro;
      // turnaround end
    },

    // Mostra il modale con i dettagli di una 
    // segnalazione
    mostraDettagliSegnalazione(segnalazione) {
      this.segnalazione = segnalazione;
      this.$modal.show('segnalazione');
      // turnaround
      this.forceRefreshSegnalazione = !this.forceRefreshSegnalazione;
      this.forceRefreshSegnalazione = !this.forceRefreshSegnalazione;
      // turnaround end
    },

     // Mostra il modale con i dettagli di una 
    // richiesta
    mostraDettagliRichiesta(richiesta) {
      this.richiesta = richiesta;
      this.$modal.show('richiesta');
      // turnaround
      this.forceRefreshRichiesta = !this.forceRefreshRichiesta;
      this.forceRefreshRichiesta = !this.forceRefreshRichiesta;
      // turnaround end
    },

    downloadEmergenza(emergenza) {
      var backupEmergenza = JSON.parse(JSON.stringify(emergenza))
      backupEmergenza['data'] = new Date ( backupEmergenza['tempo'] * 1000).toLocaleDateString();
      this.axios.post(`report/emergenza`, backupEmergenza, {responseType: 'blob'}).then(response=>{
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${emergenza.intervento}_${emergenza.strada}_${emergenza.id}.pdf`);
        document.body.appendChild(link);
        link.click();
      })
    },
    fetchTeams() {
      var params = "";
      this.axios.get(`teams/${this.lotto}${params}`).then(response => {
     
        this.teams = response.data;
        this.teamTemp = this.teams;
      }, error => {
        console.log(error);

        setTimeout(function(){

        },1000); 
      });
    }

  },
};
</script>

<style lang="scss" scoped >
.lineThrough {
  text-decoration: line-through;
    text-decoration-line: line-through;
    text-decoration-style: initial;
    text-decoration-color: initial;
}
 
.dropdown {
    position: relative;
    display: block;
    margin: auto;
    .dropdown-input {
      background: #fff;
      cursor: pointer;
      border: 1px solid #e7ecf5;
      border-radius: 3px;
      color: #333;
      display: block;
      font-size: .8em;
      padding: 6px;
      min-width: 250px;
      max-width: 250px;
      &:hover {
        background: #f8f8fa;
      }
    }
    .dropdown-content {
      position: absolute;
      background-color: #fff;
      min-width: 248px;
      max-width: 248px;
      max-height: 248px;
      border: 1px solid #e7ecf5;
      box-shadow: 0px -8px 34px 0px rgba(0,0,0,0.05);
      overflow: auto;
      z-index: 1;
      .dropdown-item {
        color: black;
        font-size: .7em;
        line-height: 1em;
        padding: 8px;
        text-decoration: none;
        display: block;
        cursor: pointer;
        &:hover {
          background-color: #e7ecf5;
        }
      }
    }
    .dropdown:hover .dropdowncontent {
      display: block;
    }
}
     
</style>
